export default "__VITE_ASSET__8463216b__"